import request from '@/utils/request'
import { accountPrefix, wisdomsitePrefix } from './config'
import { exportExcel } from '@/utils/download'

export function siteProjectDataTree(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteProject/companyAndTeam',
    method: 'post',
    data
  })
}
export function listByProject(data) {
  return request({
    url: wisdomsitePrefix + '/front/sitePerson/listByProject',
    method: 'post',
    data
  })
}
export function addSitePerson(data) {
  return request({
    url: wisdomsitePrefix + '/front/sitePerson/add',
    method: 'post',
    data
  })
}
export function sitePersonBlacklistById(data) {
  return request({
    url: wisdomsitePrefix + '/front/sitePersonBlacklist/listByPerson',
    method: 'post',
    data
  })
}
export function updateSitePerson(data) {
  return request({
    url: wisdomsitePrefix + '/front/sitePerson/update',
    method: 'post',
    data
  })
}
export function deleteSitePerson(data) {
  return request({
    url: wisdomsitePrefix + '/front/sitePerson/delete',
    method: 'post',
    data
  })
}
export function deleteByProject(data) {
  return request({
    url: wisdomsitePrefix + '/front/sitePerson/deleteByProject',
    method: 'post',
    data
  })
}
export function updateOnJobStatus(data) {
  return request({
    url: wisdomsitePrefix + '/front/sitePerson/updateOnJobStatus',
    method: 'post',
    data
  })
}
export function querySitePerson(data) {
  return request({
    url: wisdomsitePrefix + '/front/sitePerson/query',
    method: 'post',
    data
  })
}
export function queryTenementTemporaryInfo(data) {
  return request({
    url: wisdomsitePrefix + '/front/tenementTemporaryInfo/query',
    method: 'post',
    data
  })
}

// 协议上报
export function personAgreementUpload(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteAgreementUpload/personAgreementUpload',
    method: 'post',
    data
  })
}
export function personAgreementBatchUpload(data) {
  return request({
    url:
      wisdomsitePrefix +
      '/front/siteAgreementUpload/personAgreementBatchUpload',
    method: 'post',
    data
  })
}
export function addAndUpdateParamAndExecuteAddTask(data) {
  return request({
    url:
      wisdomsitePrefix +
      '/front/sitePersonAgreement/addAndUpdateParamAndExecuteAddTask',
    method: 'post',
    data
  })
}
export function addAndUpdateParamAndExecuteEditTask(data) {
  return request({
    url:
      wisdomsitePrefix +
      '/front/sitePersonAgreement/addAndUpdateParamAndExecuteEditTask',
    method: 'post',
    data
  })
}
export function unLockProjectPerson(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteAgreementUnlock/unLockProject',
    method: 'post',
    data
  })
}
export function unLockPersons(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteAgreementUnlock/unLockPerson',
    method: 'post',
    data
  })
}
export function personBatchUpdate(data) {
  return request({
    url: wisdomsitePrefix + '/front/sitePerson/batchUpdate',
    method: 'post',
    data
  })
}

// 资质证书
export function sitePersonCertList(data) {
  return request({
    url: wisdomsitePrefix + '/front/sitePersonCertInfo/listByPerson',
    method: 'post',
    data
  })
}
export function addSitePersonCert(data) {
  return request({
    url: wisdomsitePrefix + '/front/sitePersonCertInfo/add',
    method: 'post',
    data
  })
}
export function updateSitePersonCert(data) {
  return request({
    url: wisdomsitePrefix + '/front/sitePersonCertInfo/update',
    method: 'post',
    data
  })
}
export function deleteSitePersonCert(data) {
  return request({
    url: wisdomsitePrefix + '/front/sitePersonCertInfo/delete',
    method: 'post',
    data
  })
}
export function querySitePersonCert(data) {
  return request({
    url: wisdomsitePrefix + '/front/sitePersonCertInfo/query',
    method: 'post',
    data
  })
}
// 银行卡
export function bankCardList(data) {
  return request({
    url: wisdomsitePrefix + '/front/sitePersonBankCard/queryPage',
    method: 'post',
    data
  })
}
export function addSitePersonBankCard(data) {
  return request({
    url: wisdomsitePrefix + '/front/sitePersonBankCard/add',
    method: 'post',
    data
  })
}
export function updateSitePersonBankCard(data) {
  return request({
    url: wisdomsitePrefix + '/front/sitePersonBankCard/update',
    method: 'post',
    data
  })
}
export function deleteSitePersonBankCard(data) {
  return request({
    url: wisdomsitePrefix + '/front/sitePersonBankCard/delete',
    method: 'post',
    data
  })
}

export function downloadDefaultTemplate(data) {
  return exportExcel(
    wisdomsitePrefix + '/front/sitePerson/downloadDefaultTemplate',
    data
  )
}
export function sitePersonExportByProject(data) {
  return request({
    url: wisdomsitePrefix + '/front/sitePerson/exportByProject',
    method: 'post',
    data
  })
}

export function personQueryExtendByProject(data) {
  return request({
    url: wisdomsitePrefix + '/front/sitePersonAgreement/queryExtendByProject',
    method: 'post',
    data
  })
}
export function queryBaseInfoExtendByProject(data) {
  return request({
    url:
      wisdomsitePrefix +
      '/front/sitePersonAgreement/queryBaseInfoExtendByProject',
    method: 'post',
    data
  })
}
export function personAddAndUpdateParamByProject(data) {
  return request({
    url:
      wisdomsitePrefix +
      '/front/sitePersonAgreement/addAndUpdateParamByProject',
    method: 'post',
    data
  })
}
// 临时人员
export function tenementTemporaryInfoList(data) {
  return request({
    url: wisdomsitePrefix + '/front/tenementTemporaryInfo/queryPage',
    method: 'post',
    data
  })
}
export function genTemporaryInfoQrCodeData(data) {
  return request({
    url:
      accountPrefix +
      '/front/tenementBusinessQrCodeGen/genTemporaryInfoQrCodeData',
    method: 'post',
    data
  })
}
export function deleteTemporaryInfo(data) {
  return request({
    url: wisdomsitePrefix + '/front/tenementTemporaryInfo/deleteTemporaryInfo',
    method: 'post',
    data
  })
}
export function updateTenementTemporaryInfo(data) {
  return request({
    url: wisdomsitePrefix + '/front/tenementTemporaryInfo/update',
    method: 'post',
    data
  })
}

// 劳务合同
export function addSitePersonContractInfo(data) {
  return request({
    url: wisdomsitePrefix + '/front/sitePersonContractInfo/add',
    method: 'post',
    data
  })
}
export function querySitePersonContractInfo(data) {
  return request({
    url: wisdomsitePrefix + '/front/sitePersonContractInfo/query',
    method: 'post',
    data
  })
}
export function updateSitePersonContractInfo(data) {
  return request({
    url: wisdomsitePrefix + '/front/sitePersonContractInfo/update',
    method: 'post',
    data
  })
}
export function deleteSitePersonContractInfo(data) {
  return request({
    url: wisdomsitePrefix + '/front/sitePersonContractInfo/delete',
    method: 'post',
    data
  })
}

// 培训人员信息
export function siteTrainPersonRelationPageList(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteTrainPersonRelation/pageList',
    method: 'post',
    data
  })
}
export function siteTrainPersonRelationPersonList(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteTrainPersonRelation/personList',
    method: 'post',
    data
  })
}
export function queryPersonAgreementLastPullInfo(data) {
  return request({
    url:
      wisdomsitePrefix +
      '/front/siteAgreementPull/queryPersonAgreementLastPullInfo',
    method: 'post',
    data
  })
}
export function queryPullPersonTaskDetail(data) {
  return request({
    url:
      wisdomsitePrefix +
      '/front/siteVerifyDevicePullPerson/queryPullPersonTaskDetail',
    method: 'post',
    data
  })
}
export function getImportWhiteListLogInfoDetail(data) {
  return request({
    url:
      wisdomsitePrefix +
      '/front/siteLprWhiteList/getImportWhiteListLogInfoDetail',
    method: 'post',
    data
  })
}

export function addSiteTrainPersonRelation(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteTrainPersonRelation/add',
    method: 'post',
    data
  })
}

export function deleteSiteTrainPersonRelation(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteTrainPersonRelation/delete',
    method: 'post',
    data
  })
}

export function updateCheckInStatus(data) {
  return request({
    url:
      wisdomsitePrefix + '/front/siteTrainPersonRelation/updateCheckInStatus',
    method: 'post',
    data
  })
}

export function siteTrainPersonRelationListByPerson(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteTrainPersonRelation/listByPerson',
    method: 'post',
    data
  })
}

// 广州住建

export function unLockPerson(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteProjectAgreement/unLockPerson',
    method: 'post',
    data
  })
}
export function unLockProject(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteProjectAgreement/unLockProject',
    method: 'post',
    data
  })
}
export function getLockMsg(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteProjectAgreement/getLockMsg',
    method: 'post',
    data
  })
}
export function exceptionByProject(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteAgreementUpload/exceptionByProject',
    method: 'post',
    data
  })
}
export function exportLockPerson(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteProjectAgreement/exportLockPerson',
    method: 'post',
    data
  })
}

// 协议上报
export function zqxyPersonInfo(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteAgreement/zqxyPersonInfo',
    method: 'post',
    data
  })
}
export function pullPerson(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteAgreementPull/pullPerson',
    method: 'post',
    data
  })
}
export function querySiteBusinessQrcodeInfo(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteBusinessQrcodeInfo/query',
    method: 'post',
    data
  })
}
export function queryTenementQrcodeRegisterConfig(data) {
  return request({
    url: accountPrefix + '/front/tenementQrcodeRegisterConfig/queryConfig',
    method: 'post',
    data
  })
}
// 云考勤
export function caListByProject(data) {
  return request({
    url: wisdomsitePrefix + '/front/ca/listByProject',
    method: 'post',
    data
  })
}

// 劳务人员审批
export function sitePersonAddRecordList(data) {
  return request({
    url: wisdomsitePrefix + '/front/sitePersonAddRecord/pageList',
    method: 'post',
    data
  })
}
export function addCaPerson(data) {
  return request({
    url: wisdomsitePrefix + '/front/ca/add',
    method: 'post',
    data
  })
}

// 黑名单
export function sitePersonBlacklist(data) {
  return request({
    url: wisdomsitePrefix + '/front/sitePersonBlacklist/listByProject',
    method: 'post',
    data
  })
}
export function deleteCaPerson(data) {
  return request({
    url: wisdomsitePrefix + '/front/ca/delete',
    method: 'post',
    data
  })
}

export function downloadBlackDefaultTemplate(data) {
  return exportExcel(
    wisdomsitePrefix + '/front/sitePersonBlacklist/downloadDefaultTemplate',
    data
  )
}
// 考勤报表
export function dayByProject(data) {
  return request({
    url: wisdomsitePrefix + '/front/sitePersonAttendance/dayByProject',
    method: 'post',
    data
  })
}
export function caPersonStatus(data) {
  return request({
    url: wisdomsitePrefix + '/front/ca/caPersonStatus',
    method: 'post',
    data
  })
}
export function querySitePersonAddRecord(data) {
  return request({
    url: wisdomsitePrefix + '/front/sitePersonAddRecord/query',
    method: 'post',
    data
  })
}
export function caStatusByProject(data) {
  return request({
    url: wisdomsitePrefix + '/front/ca/caStatusByProject',
    method: 'post',
    data
  })
}
export function monthByProject(data) {
  return request({
    url: wisdomsitePrefix + '/front/sitePersonAttendance/monthByProject',
    method: 'post',
    data
  })
}
export function monthDateAttendance(data) {
  return request({
    url: wisdomsitePrefix + '/front/sitePersonAttendance/monthDateAttendance',
    method: 'post',
    data
  })
}
export function addBlackPerson(data) {
  return request({
    url: wisdomsitePrefix + '/front/sitePersonBlacklist/add',
    method: 'post',
    data
  })
}
export function quarteByProject(data) {
  return request({
    url: wisdomsitePrefix + '/front/sitePersonAttendance/quarteByProject',
    method: 'post',
    data
  })
}
export function updateSitePersonAddRecord(data) {
  return request({
    url: wisdomsitePrefix + '/front/sitePersonAddRecord/update',
    method: 'post',
    data
  })
}
export function noAttendanceByProject(data) {
  return request({
    url: wisdomsitePrefix + '/front/sitePersonAttendance/noAttendanceByProject',
    method: 'post',
    data
  })
}
export function exportSitePersonBlacklist(data) {
  return request({
    url: wisdomsitePrefix + '/front/sitePersonBlacklist/exportByProject',
    method: 'post',
    data
  })
}
export function ruleByProject(data) {
  return request({
    url: wisdomsitePrefix + '/front/sitePersonAttendance/ruleByProject',
    method: 'post',
    data
  })
}
export function monthlyReport(data) {
  return request({
    url: wisdomsitePrefix + '/front/sitePersonAttendance/monthlyReport',
    method: 'post',
    data
  })
}
export function exportdMonthlyReport(data) {
  return request({
    url: wisdomsitePrefix + '/front/sitePersonAttendance/exportdMonthlyReport',
    method: 'post',
    data
  })
}
// 访客人员审批
export function siteTemporaryAddRecordList(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteTemporaryAddRecord/pageList',
    method: 'post',
    data
  })
}
export function updateRule(data) {
  return request({
    url: wisdomsitePrefix + '/front/sitePersonAttendance/updateRule',
    method: 'post',
    data
  })
}
export function removeSitePersonBlacklist(data) {
  return request({
    url: wisdomsitePrefix + '/front/sitePersonBlacklist/toPerson',
    method: 'post',
    data
  })
}
export function removeSitePersonBlack(data) {
  return request({
    url: wisdomsitePrefix + '/front/sitePersonBlacklist/remove',
    method: 'post',
    data
  })
}
export function exportdDayAttendance(data) {
  return request({
    url: wisdomsitePrefix + '/front/sitePersonAttendance/exportDayAttendance',
    method: 'post',
    data
  })
}
export function querySiteTemporaryAddRecord(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteTemporaryAddRecord/query',
    method: 'post',
    data
  })
}
export function exportdMonthAttendance(data) {
  return request({
    url: wisdomsitePrefix + '/front/sitePersonAttendance/exportMonthAttendance',
    method: 'post',
    data
  })
}
export function exportMonthDateAttendance(data) {
  return request({
    url:
      wisdomsitePrefix +
      '/front/sitePersonAttendance/exportMonthDateAttendance',
    method: 'post',
    data
  })
}
export function updateSitePersonBlacklist(data) {
  return request({
    url: wisdomsitePrefix + '/front/sitePersonBlacklist/update',
    method: 'post',
    data
  })
}
export function updateSiteTemporaryAddRecord(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteTemporaryAddRecord/update',
    method: 'post',
    data
  })
}
export function updateSiteKeyManagerApplyRecord(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteKeyManagerApplyRecord/update',
    method: 'post',
    data
  })
}
export function querySitePersonBlacklist(data) {
  return request({
    url: wisdomsitePrefix + '/front/sitePersonBlacklist/query',
    method: 'post',
    data
  })
}

export function getPersonInfoQrCodeData(data) {
  return request({
    url:
      accountPrefix +
      '/front/tenementBusinessQrCodeGen/genPersonInfoQrCodeData',
    method: 'post',
    data
  })
}
export function exportdQuarterAttendance(data) {
  return request({
    url:
      wisdomsitePrefix + '/front/sitePersonAttendance/exportQuarterAttendance',
    method: 'post',
    data
  })
}
export function updateSiteBusinessQrcodeInfo(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteBusinessQrcodeInfo/update',
    method: 'post',
    data
  })
}
export function updateTenementQrcodeRegisterConfig(data) {
  return request({
    url: accountPrefix + '/front/tenementQrcodeRegisterConfig/updateConfig',
    method: 'post',
    data
  })
}
export function updateTemporary(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteBusinessQrcodeInfo/updateTemporary',
    method: 'post',
    data
  })
}
export function exportdNoAttendanceAttendance(data) {
  return request({
    url:
      wisdomsitePrefix +
      '/front/sitePersonAttendance/exportNoAttendanceAttendance',
    method: 'post',
    data
  })
}

// 人员统计

export function areaStatistics(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteArea/areaStatistics',
    method: 'post',
    data
  })
}
export function areaPersonList(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteArea/areaPersonList',
    method: 'post',
    data
  })
}
export function areaPersonRecord(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteArea/areaPersonRecord',
    method: 'post',
    data
  })
}
export function siteAreaExportByProject(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteArea/exportByProject',
    method: 'post',
    data
  })
}
export function areaInJobPerson(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteArea/areaInJobPerson',
    method: 'post',
    data
  })
}
export function attendanceQueryByDate(data) {
  return request({
    url: wisdomsitePrefix + '/front/sitePersonAttendance/queryByDate',
    method: 'post',
    data
  })
}
export function caRuleUpdate(data) {
  return request({
    url: wisdomsitePrefix + '/front/ca/caRuleUpdate',
    method: 'post',
    data
  })
}
export function updatePersonCa(data) {
  return request({
    url: wisdomsitePrefix + '/front/ca/updatePersonCa',
    method: 'post',
    data
  })
}

// 手动协议上报
export function siteAgreementManualUploadList(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteAgreementManualUpload/pageByProject',
    method: 'post',
    data
  })
}
export function addSiteAgreementManualUpload(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteAgreementManualUpload/add',
    method: 'post',
    data
  })
}
export function siteAgreementManualUploadListByRecord(data) {
  return request({
    url:
      wisdomsitePrefix + '/front/siteAgreementManualUpload/pageDetailByRecord',
    method: 'post',
    data
  })
}
export function hbssmzPersonList(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteAgreementCustom/hbssmzPersonList',
    method: 'post',
    data
  })
}
export function hbsbdsmzPersonList(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteAgreementCustom/hbsbdsmzPersonList',
    method: 'post',
    data
  })
}
export function hbssmzTeamList(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteAgreementCustom/hbssmzTeamList',
    method: 'post',
    data
  })
}
export function hbsbdsmzTeamList(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteAgreementCustom/hbsbdsmzTeamList',
    method: 'post',
    data
  })
}
export function hbssmzPersonManagerList(data) {
  return request({
    url:
      wisdomsitePrefix + '/front/siteAgreementCustom/hbssmzPersonManagerList',
    method: 'post',
    data
  })
}
export function hbssmzPersonExtendList(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteAgreementCustom/hbssmzPersonExtendList',
    method: 'post',
    data
  })
}
export function companyManagerType(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteAgreementCustom/companyManagerType',
    method: 'post',
    data
  })
}
export function importHeadImg(data) {
  return request({
    url: wisdomsitePrefix + '/front/sitePerson/importHeadImg',
    method: 'post',
    onUploadProgress: function (progressEvent) {
      data.processCallBack(progressEvent)
    },
    data: data.data
  })
}
export function importBlackHeadImg(data) {
  return request({
    url: wisdomsitePrefix + '/front/sitePersonBlacklist/importHeadImg',
    method: 'post',
    onUploadProgress: function (progressEvent) {
      data.processCallBack(progressEvent)
    },
    data: data.data
  })
}
export function siteKeyManagerApplyRecordList(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteKeyManagerApplyRecord/pageList',
    method: 'post',
    data
  })
}
export function querySiteKeyManagerApplyRecord(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteKeyManagerApplyRecord/query',
    method: 'post',
    data
  })
}
export function addTenementTemporaryInfo(data) {
  return request({
    url: wisdomsitePrefix + '/front/tenementTemporaryInfo/add',
    method: 'post',
    data
  })
}
export function updateTemporaryInfo(data) {
  return request({
    url: wisdomsitePrefix + '/front/tenementTemporaryInfo/updateTemporaryInfo',
    method: 'post',
    data
  })
}
export function queryTemporary(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteBusinessQrcodeInfo/queryTemporary',
    method: 'post',
    data
  })
}

export function hbssmzProjectOpenPullManagerStatus(data) {
  return request({
    url:
      wisdomsitePrefix +
      '/front/siteAgreementCustom/hbssmzProjectOpenPullManagerStatus',
    method: 'post',
    data
  })
}
export function hbssmzPersonCertificateDictionaryList(data) {
  return request({
    url:
      wisdomsitePrefix +
      '/front/siteAgreementCustom/hbssmzPersonCertificateDictionaryList',
    method: 'post',
    data
  })
}
export function sitePersonSalaryReportList(data) {
  return request({
    url: wisdomsitePrefix + '/front/sitePersonSalaryReport/pageList',
    method: 'post',
    data
  })
}
export function exportSitePersonSalaryReport(data) {
  return request({
    url:
      wisdomsitePrefix +
      '/front/sitePersonSalaryReport/exportSalaryReportByProject',
    method: 'post',
    data
  })
}
export function batchUpdatePersonType(data) {
  return request({
    url: wisdomsitePrefix + '/front/sitePerson/batchUpdatePersonType',
    method: 'post',
    data
  })
}
export function hbsbdsmzBatchUpdatePersonType(data) {
  return request({
    url:
      wisdomsitePrefix +
      '/front/siteAgreementCustom/hbsbdsmzBatchUpdatePersonType',
    method: 'post',
    data
  })
}
export function hbssmzBatchUpdatePersonType(data) {
  return request({
    url:
      wisdomsitePrefix +
      '/front/siteAgreementCustom/hbssmzBatchUpdatePersonType',
    method: 'post',
    data
  })
}
export function exportCaPersonByProject(data) {
  return request({
    url: wisdomsitePrefix + '/front/ca/exportCaPersonByProject',
    method: 'post',
    data
  })
}

export function downloadBankCardDefaultTemplate(data) {
  return exportExcel(
    wisdomsitePrefix + '/front/sitePersonBankCard/downloadDefaultTemplate',
    data
  )
}

export function siteProjectBankCardList(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteProjectBankCard/queryPage',
    method: 'post',
    data
  })
}
export function addSiteProjectBankCard(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteProjectBankCard/add',
    method: 'post',
    data
  })
}
export function deleteSiteProjectBankCard(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteProjectBankCard/delete',
    method: 'post',
    data
  })
}
export function updateSiteProjectBankCard(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteProjectBankCard/update',
    method: 'post',
    data
  })
}
export function sitePersonContractInfoList(data) {
  return request({
    url: wisdomsitePrefix + '/front/sitePersonContractInfo/pageList',
    method: 'post',
    data
  })
}
export function salaryStatistics(data) {
  return request({
    url:
      wisdomsitePrefix + '/front/sitePersonSalarySettleRecord/salaryStatistics',
    method: 'post',
    data
  })
}
export function sitePersonSalarySettleRecordList(data) {
  return request({
    url: wisdomsitePrefix + '/front/sitePersonSalarySettleRecord/pageList',
    method: 'post',
    data
  })
}
export function salarySettle(data) {
  return request({
    url: wisdomsitePrefix + '/front/sitePersonSalarySettleRecord/salarySettle',
    method: 'post',
    data
  })
}
export function reUploadSitePersonSalarySettleRecord(data) {
  return request({
    url: wisdomsitePrefix + '/front/sitePersonSalarySettleRecord/reUpload',
    method: 'post',
    data
  })
}
export function getImportBankCardDetail(data) {
  return request({
    url: wisdomsitePrefix + '/front/sitePersonBankCard/getImportBankCardDetail',
    method: 'post',
    data
  })
}

export function yjtPersonSchedulingInfo(data) {
  return request({
    url:
      wisdomsitePrefix + '/front/siteAgreementCustom/yjtPersonSchedulingInfo',
    method: 'post',
    data
  })
}
export function queryBlacklistImportDetail(data) {
  return request({
    url:
      wisdomsitePrefix + '/front/tenementFileTask/queryBlacklistImportDetail',
    method: 'post',
    data
  })
}

export function companyAttendStatisticsDay(data) {
  return request({
    url:
      wisdomsitePrefix +
      '/front/siteCompanyAttendStatistics/companyAttendStatisticsDay',
    method: 'post',
    data
  })
}
export function exportDayStatistics(data) {
  return request({
    url:
      wisdomsitePrefix +
      '/front/siteCompanyAttendStatistics/exportDayStatistics',
    method: 'post',
    data
  })
}
export function companyAttendStatisticsWeek(data) {
  return request({
    url:
      wisdomsitePrefix +
      '/front/siteCompanyAttendStatistics/companyAttendStatisticsWeek',
    method: 'post',
    data
  })
}
export function exportWeekStatistics(data) {
  return request({
    url:
      wisdomsitePrefix +
      '/front/siteCompanyAttendStatistics/exportWeekStatistics',
    method: 'post',
    data
  })
}
export function uploadComparePhotoFaceHttp(data) {
  return request({
    url: wisdomsitePrefix + '/front/fc/uploadComparePhotoFaceHttp',
    method: 'post',
    data
  })
}
export function contractQueryExtendByProject(data) {
  return request({
    url:
      wisdomsitePrefix +
      '/front/sitePersonContractAgreement/queryExtendByProject',
    method: 'post',
    data
  })
}
export function queryContractBaseInfoExtendByProject(data) {
  return request({
    url:
      wisdomsitePrefix +
      '/front/sitePersonContractAgreement/queryBaseInfoExtendByProject',
    method: 'post',
    data
  })
}
export function saveContractParamByProject(data) {
  return request({
    url:
      wisdomsitePrefix +
      '/front/sitePersonContractAgreement/addAndUpdateParamByProject',
    method: 'post',
    data
  })
}
export function saveCertParamByProject(data) {
  return request({
    url:
      wisdomsitePrefix +
      '/front/sitePersonCertAgreement/addAndUpdateParamByProject',
    method: 'post',
    data
  })
}
export function saveContractParamAndExecuteEditTask(data) {
  return request({
    url:
      wisdomsitePrefix +
      '/front/sitePersonContractAgreement/addAndUpdateParamAndExecuteEditTask',
    method: 'post',
    data
  })
}
export function saveContractParamAndExecuteAddTask(data) {
  return request({
    url:
      wisdomsitePrefix +
      '/front/sitePersonContractAgreement/addAndUpdateParamAndExecuteAddTask',
    method: 'post',
    data
  })
}
export function zqxyPersonContractInfo(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteAgreement/zqxyPersonContractInfo',
    method: 'post',
    data
  })
}
export function zqxyPersonCertInfo(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteAgreement/zqxyPersonCertInfo',
    method: 'post',
    data
  })
}
export function personContractAgreementUpload(data) {
  return request({
    url:
      wisdomsitePrefix +
      '/front/siteAgreementUpload/personContractAgreementUpload',
    method: 'post',
    data
  })
}
export function personCertAgreementUpload(data) {
  return request({
    url:
      wisdomsitePrefix + '/front/siteAgreementUpload/personCertAgreementUpload',
    method: 'post',
    data
  })
}
export function queryCertExtendByProject(data) {
  return request({
    url:
      wisdomsitePrefix + '/front/sitePersonCertAgreement/queryExtendByProject',
    method: 'post',
    data
  })
}
export function saveCertParamAndExecuteAddTask(data) {
  return request({
    url:
      wisdomsitePrefix +
      '/front/sitePersonCertAgreement/addAndUpdateParamAndExecuteAddTask',
    method: 'post',
    data
  })
}
export function saveCertParamAndExecuteEditTask(data) {
  return request({
    url:
      wisdomsitePrefix +
      '/front/sitePersonCertAgreement/addAndUpdateParamAndExecuteEditTask',
    method: 'post',
    data
  })
}
export function addSiteProjectSettleTask(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteProjectSettleTask/addTask',
    method: 'post',
    data
  })
}
export function settleStatistics(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteProjectSettleTask/settleStatistics',
    method: 'post',
    data
  })
}
export function siteProjectSettleTaskPersonRecordList(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteProjectSettleTaskPersonRecord/pageList',
    method: 'post',
    data
  })
}
export function siteProjectSettleTaskList(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteProjectSettleTask/pageList',
    method: 'post',
    data
  })
}
export function deleteSiteProjectSettleTask(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteProjectSettleTask/deleteTask',
    method: 'post',
    data
  })
}
export function parollSiteProjectSettleTaskPerson(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteProjectSettleTaskPersonRecord/payroll',
    method: 'post',
    data
  })
}
export function batchSettleSiteProjectSettleTaskPerson(data) {
  return request({
    url:
      wisdomsitePrefix + '/front/siteProjectSettleTaskPersonRecord/batchSettle',
    method: 'post',
    data
  })
}
export function updateSiteProjectSettleTask(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteProjectSettleTask/updateSettleStatus',
    method: 'post',
    data
  })
}
export function settleSiteProjectSettleTaskPerson(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteProjectSettleTaskPersonRecord/settle',
    method: 'post',
    data
  })
}
export function siteProjectSettleTaskPersonAttendRecordList(data) {
  return request({
    url:
      wisdomsitePrefix +
      '/front/siteProjectSettleTaskPersonAttendRecord/listByTaskPerson',
    method: 'post',
    data
  })
}
export function exportPayroll(data) {
  return request({
    url:
      wisdomsitePrefix +
      '/front/siteProjectSettleTaskPersonRecord/exportPayroll',
    method: 'post',
    data
  })
}
export function batchUpdateSiteProjectSettleTaskPersonRecord(data) {
  return request({
    url:
      wisdomsitePrefix + '/front/siteProjectSettleTaskPersonRecord/batchUpdate',
    method: 'post',
    data
  })
}
